// extracted by mini-css-extract-plugin
export default {"cls1":"StickyWorkCardHeader-cls1_sZz","cls2":"StickyWorkCardHeader-cls2_VRj StickyWorkCardHeader-cls1_sZz"};